import { Button, makeStyles, Typography } from '@material-ui/core';
import React, { FC, useEffect } from 'react';
import { Page } from 'src/components';
import { EmailerForm } from './components/EmailerForm';
import { useEmailer } from 'src/hooks/email/useEmailer';
import { useParams } from 'react-router';

const useStyles = makeStyles(() => ({
  root: {
    padding: '1em',
    display: 'flex',
    flexDirection: 'column',
    gap: '1em'
  },
  header: { display: 'flex', justifyContent: 'space-between' }
}));

export const EmailerDetailsView: FC = () => {
  const classes = useStyles();
  const { id } = useParams();
  const {
    formik,
    emailerDetails,
    isLoading,
    canUpdateEmailer,

    getEmailerDetails
  } = useEmailer({
    emailerId: id ? +id : 0
  });

  useEffect(() => {
    if (id) {
      getEmailerDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // overwrite/populate formik values if details is fetched
  useEffect(() => {
    if (emailerDetails) {
      formik.resetForm({ values: emailerDetails });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailerDetails]);

  return (
    <Page className={classes.root} title="Emailer Details">
      <Typography color="textPrimary" gutterBottom variant="h3">
        Emailer
      </Typography>

      <EmailerForm formik={formik} id={id ? +id : 0} />

      {canUpdateEmailer ? (
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            disabled={isLoading}
            variant="contained"
            color="primary"
            onClick={() => formik?.handleSubmit()}
          >
            Save Details
          </Button>
        </div>
      ) : null}
    </Page>
  );
};
